import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllTransferInfo, GetAvailableStockResponse } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { SaleOrderIdRequest } from '../stock/dto/sale-order-id.request';
import { PackingStockTransferData } from './dto/packing-stock-transfer.model';
import { TransferIdRequest } from './dto/transfer-id.request';
import { TransferMaterialRequest } from './dto/transfer-material.request';
import { TransferMaterialService } from './transfer-material.service';

@ApiTags('Transfer Material')
@Controller('transfer-material')
export class TransferMaterialController {
    constructor(private service: TransferMaterialService, private readonly applicationExceptionHandler: ApplicationExceptionHandler,) { }

    /**
     * 
     * @returns if material transfer created successfully
     */
    @Post('/createTransferMaterial')
    async createTransferMaterial(@Body() createData: PackingStockTransferData): Promise<CommonResponse> {
        try {
            return this.service.createTransferMaterial(createData);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('/getTransferMaterialDCData')
    async getTransferMaterialDCData(@Body() req: TransferMaterialRequest): Promise<AllTransferInfo> {
        try {
            return this.service.getTransferMaterialDCData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllTransferInfo, error)
        }
    }

    @Post('/getTransferMaterialMRNData')
    async getTransferMaterialMRNData(@Body() req: TransferMaterialRequest): Promise<AllTransferInfo> {
        try {
            return this.service.getTransferMaterialMRNData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllTransferInfo, error)
        }
    }

    @Post('/TransferMaterialDetailInfo')
    async TransferMaterialDetailInfo(@Body() req: TransferIdRequest): Promise<AllTransferInfo> {
        try {
            return this.service.TransferMaterialDetailInfo(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllTransferInfo, error)
        }
    }

    @Post('/ReceiveStock')
    async ReceiveStock(@Body() req: TransferIdRequest): Promise<AllTransferInfo> {
        try {
            return this.service.ReceiveStock(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllTransferInfo, error)
        }
    }

    @Post('/getSaleOrderRequiredItemDetails')
    async getSaleOrderRequiredItemDetails(@Body() req: SaleOrderIdRequest): Promise<GetAvailableStockResponse> {
        try {
            return await this.service.getSaleOrderRequiredItemDetails(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(GetAvailableStockResponse, err);
        }
    }

    @Post('/getTransferedStockDetails')
    async getTransferedStockDetails(@Body() req: TransferIdRequest): Promise<CommonResponse> {
        try {
            return await this.service.getTransferedStockDetails(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

}
